<template>
  <v-text-field
    v-model="number"
    class="input-center"
    :single-line="dense"
    :dense="dense"
    :disabled="disabled"
    :label="dense ? '' : label"
    :hide-details="
      showMessages
        ? false
        : dense
        ? !errorMessages || errorMessages.length == 0
        : false
    "
    type="number"
    :min="min ? min : 0"
    :max="max ? max : 99999999"
    :error-messages="errorMessages"
    @blur="checkInputValue()"
    style="min-width: 150px; max-width: 150px; margin-left: auto"
    @input="
      changeInputByHandFlg ? $emit('input', number) : '';
      changeInputByHandFlg ? $emit('changeInputByHand') : '';
    "
  >
    <template v-slot:prepend-inner>
      <v-icon
        :disabled="disabled"
        x-small
        @click.stop="
          number =
            Number(number) - 1 >= (min ? min : 0)
              ? $numberFormatter.formatWithDotNoMoreThan(
                  Number(number) - 1,
                  Number.isInteger(dot) ? dot : 2,
                  true
                )
              : min
              ? min
              : 0;
          changeInputByHandFlg ? $emit('input', number) : '';
          changeInputByHandFlg ? $emit('changeInputByHand') : '';
        "
        class="pt-2 pb-1 primary--text"
      >
        fa-minus
      </v-icon>
    </template>
    <template v-slot:append>
      <v-icon
        :disabled="disabled"
        x-small
        @click.stop="
          number = number
            ? Number(number) + 1 <= (max ? max : $consts.maxValue())
              ? $numberFormatter.formatWithDotNoMoreThan(
                  Number(number) + 1,
                  Number.isInteger(dot) ? dot : 2,
                  true
                )
              : max
            : 1;
          changeInputByHandFlg ? $emit('input', number) : '';
          changeInputByHandFlg ? $emit('changeInputByHand') : '';
        "
        class="pt-2 pb-1 primary--text"
      >
        fa-plus
      </v-icon>
    </template>
    <template v-slot:append-outer> <slot name="append"></slot> </template>
  </v-text-field>
</template>

<script>
export default {
  name: "NumberInput",

  props: {
    value: [String, Number],
    label: String,
    dot: Number,
    min: Number,
    max: Number,
    dense: Boolean,
    disabled: Boolean,
    showMessages: Boolean,
    errorMessages: Array,
    allowNegative: Boolean,
    changeInputByHandFlg: Boolean,
  },

  data: () => ({
    number: "",
  }),

  methods: {
    checkInputValue() {
      if (
        this.number != "" &&
        this.number != undefined &&
        typeof this.number != "undefined"
      ) {
        this.number =
          this.number >= (this.min ? this.min : 0)
            ? this.number
            : this.min
            ? this.min
            : 0;
        this.number =
          this.number <= (this.max ? this.max : 99999999)
            ? this.number
            : this.max;
        this.number = this.$numberFormatter.formatWithDotNoMoreThan(
          this.number,
          Number.isInteger(this.dot) ? this.dot : 2,
          true
        );
      }
    },
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        this.number = this.value;
      },
    },
    number: {
      handler() {
        this.$emit("input", this.number);
      },
    },
  },
};
</script>
